//removeIf(production)
import ClaroluzData from "../../../../../domain/entities/claroluz-data";
//removeIf(production)
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ExternalStatus from "../../../../../enums/external-status";
import ClaroluzOffers from "../offers/offers";
import translation from "../../../../../../lang/es.json";
import TopGasAlert from "../../../../../enums/top-gas-alert";
//endRemoveIf(production)

class ClaroluzComparator {
    private data: ClaroluzData;

    constructor(data: ClaroluzData) {
        this.data = data;
        this.init();
    }

    private init() {
        let topGas = this.data.bill!.topGas;
        let headerHeight = 0;
        const comparator = document.querySelector('.claroluz-comparator') as HTMLElement;

        // only in desktop
        if (window.innerWidth > 1024) {
            if (document.querySelector('.elementor-location-header')) {
                headerHeight = document.querySelector('.elementor-location-header')!.clientHeight;

                headerHeight = headerHeight > 75 ? headerHeight : 76;
            } else if (document.getElementById("site-header")) {
                headerHeight = document.getElementById("site-header")!.clientHeight;
            }

            comparator.style.top = headerHeight + 'px';
            comparator.style.height = `calc(100vh - ${headerHeight}px)`;
        }
        

        document.querySelector('.claroluz-card-current .claroluz-current-value')!.innerHTML = ClaroluzValueFormat.of(this.data.bill!.amount) ?? '0' + '€';
        document.querySelector('body')?.classList.add('comparator');
        comparator.classList.add('show');
        comparator.scrollTop = 0;
        document.querySelector('.offer-result-message')!.classList.add('display-none');

        if (appProperties().debug) {
            console.log('topGas', topGas);
        }

        if (topGas.hasTopGas) {
            document.querySelector('.claroluz-card-current .topgas-value')!.innerHTML = ClaroluzValueFormat.of(topGas.value) + '€';
            document.querySelector('.claroluz-card-current .topgas-offer')!.innerHTML = ClaroluzValueFormat.of(topGas.offerValue) + '€';

            document.querySelector('.claroluz-card-current .topgas-value')!.classList.remove('display-none');
            document.querySelector('.claroluz-card-current .topgas-offer')!.classList.add('display-none');

            document.querySelector('.claroluz-card-current .topgas')!.setAttribute('data-topgas', 'offer');
            document.querySelector('.claroluz-card-current .topgas')!.classList.remove('hide');
        } else {
            document.querySelector('.claroluz-card-current .topgas')!.setAttribute('data-topgas', 'hide');
            document.querySelector('.claroluz-card-current .topgas')!.classList.add('hide');
        }

        if (topGas.hasAlert) {
            switch (topGas.alert) {
                case TopGasAlert.NOT_PAYING:
                    document.querySelector('.offer-result-message')!.innerHTML = translation.comparator.results.offers.topGasAlert.notPaying;
                    document.querySelector('.claroluz-card-current .topgas')!.classList.add('hide');

                    break;
                case TopGasAlert.PAYING:
                    document.querySelector('.offer-result-message')!.innerHTML = translation.comparator.results.offers.topGasAlert.paying;
                    break;
                case TopGasAlert.PAYING_ESTIMATED:
                    document.querySelector('.offer-result-message')!.innerHTML = translation.comparator.results.offers.topGasAlert.payingEstimated;
                    break;
                case TopGasAlert.PAYING_NOT_IDENTIFIED:
                    document.querySelector('.offer-result-message')!.innerHTML = translation.comparator.results.offers.topGasAlert.payingNotIdentified;
                    document.querySelector('.claroluz-card-current .topgas')!.classList.add('hide');
                    break;

                default:
                    if (appProperties().dev) {
                        console.error('TopGasAlert not found', topGas.alert);
                    }
                    break;
            }

            document.querySelector('.offer-result-message')!.classList.remove('display-none');
        }

        new ClaroluzEvents(appProperties(), 'comparator', 'comparator', 'open');


        if (this.data.status == ExternalStatus.CLAROLUZ_SUCCESS) {
            new ClaroluzOffers(this.data);

            new ClaroluzEvents(appProperties(), 'comparator', 'offers', 'has-offers');
        } else {
            let containerNoOffers = document.querySelector('.claroluz-nooffers-container')!;
            // @ts-ignore
            containerNoOffers.querySelector('.no-offers-form-cups')!.value = this.data.bill!.cups;

            if (!this.data.bill!.topGas.hasTopGas && this.data.bill!.yearlySave > 0) {
                
                containerNoOffers.querySelector('.yearly-save')!.innerHTML = ClaroluzValueFormat.of(this.data.bill!.yearlySave) + '€/año';
                containerNoOffers.querySelector('.default-msg')!.classList.add('display-none');
                containerNoOffers.querySelector('.yearly-save-msg')!.classList.remove('display-none');
            } else {
                
                containerNoOffers.querySelector('.default-msg')!.classList.remove('display-none');
                containerNoOffers.querySelector('.yearly-save-msg')!.classList.add('display-none');
            }

            new ClaroluzNoOffers();

            new ClaroluzEvents(appProperties(), 'comparator', 'offers', 'no-offers');
        }
    }
}

//removeIf(production)
export default ClaroluzComparator;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)